export const normaliseString = (s: string) => s.toLowerCase().trim();
